import { render, staticRenderFns } from "./AccountCreate.vue?vue&type=template&id=93464d38&scoped=true&"
import script from "./AccountCreate.vue?vue&type=script&lang=js&"
export * from "./AccountCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93464d38",
  null
  
)

export default component.exports